import React from 'react';
import {
  Player,
  EmptyPlayerSlot,
} from './final.js';

class PlayersList extends React.Component {
  render() {
    const { game, flag } = this.props;
    
    const playersList = game.players.map((player, i) => {
      // console.log('Processing player:', player);

      if (player._number_of_friends === 1) {
        return [
          <Player key={0} player={player} flag={''} />,
          <Player
            key={1}
            player={player}
            flag={flag}
          />,
        ];
      } else {
        return <Player key={i} player={player} flag={''} />;
      }
    });

    const listNum = Array(game.emptySlotsNum()).fill(0);
    const listItems = listNum.map((num, i) => {
      return <EmptyPlayerSlot key={i} />
    });

    return (
      <div className="slots__item-place">
        <div className="row row--small">
          {playersList}
          {listItems}
        </div>
      </div>
    );
  }
}

export default PlayersList;
